import { t } from "@redotech/redo-i18n";
import { AddTag } from "@redotech/redo-return-core-common/return-flow/action";
import { ActionType } from "@redotech/redo-return-core-common/return-flow/action-enums";
import * as React from "react";
import { ActionTypeSetup, RuleTypeDetailsProps } from "./multiple-actions";

export type AddTagState = string[];

export const ADD_TAG = (
  Details: React.ComponentType<RuleTypeDetailsProps<AddTagState>>,
): ActionTypeSetup<AddTagState, AddTag> => ({
  get name() {
    return t("Apply tags");
  },
  description() {
    return t("Adds tags to the ticket");
  },
  Details(props: RuleTypeDetailsProps<AddTagState>) {
    return React.createElement(Details, props);
  },
  empty: [],
  fromModel(model) {
    return typeof model.tag === "string" ? [model.tag] : model.tag;
  },
  toModel(state) {
    return { type: ActionType.AddTag, tag: state };
  },
  valid(state) {
    return true;
  },
});
